var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18086 0.667336C4.1733 0.713218 4.17079 0.759101 4.17079 0.804983V7.53286L4.08769 7.36164C4.0046 7.1949 3.8913 7.0427 3.75407 6.91289L1.44644 4.71504C1.15689 4.4252 0.689811 4.37594 0.341084 4.59976C-0.0303031 4.85826 -0.110863 5.35627 0.161068 5.71101C0.183729 5.73899 0.207639 5.76584 0.232817 5.79158L4.40496 9.76653C4.72977 10.0776 5.25852 10.0776 5.58458 9.76765L9.75671 5.79158C10.0815 5.48047 10.0815 4.97801 9.75419 4.66803C9.72901 4.64341 9.70132 4.6199 9.67362 4.59976C9.32364 4.37594 8.85783 4.4252 8.56702 4.71504L6.25685 6.90841C6.13348 7.02592 6.0315 7.15909 5.95218 7.30681L5.83888 7.54517V0.848629C5.85525 0.442404 5.55688 0.0865288 5.13891 0.0104322C4.68318 -0.06007 4.25514 0.234253 4.18086 0.667336Z",
    fill: "#B61616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceDown);
export default __webpack_public_path__ + "static/media/PerformanceDown.aff3dc06a176232eaad6ffb2012d53a9.svg";
export { ForwardRef as ReactComponent };